import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  },
  container: {
    backgroundColor: theme.colors.form__background_primary,
    padding: theme.spacing(6),
    border: `2px solid ${theme.colorPalette.beige_50}`,
    borderRadius: theme.sizes.roundCorners,
    boxShadow: 'none'
  },
  pipChangeContainer: {
    backgroundColor: theme.colorPalette.beige_50,
    padding: theme.spacing(6),
    borderRadius: theme.sizes.innerCorners,
    boxShadow: 'none',
    marginTop: theme.spacing(4),
    border: 'none'
  },
  pipChangeProcessingUserContainer: {
    display: 'flex',
    padding: theme.spacing(4),
    '& img': {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(1),
      alignSelf: 'flex-start'
    }
  },
  sectionTitle: {
    fontSize: 20
  },
  sectionDescription: {
    margin: theme.spacing(2, 0)
  },
  pipChangeDescription: {
    fontSize: 14,
    margin: theme.spacing(2, 0)
  },
  linkSection: {
    display: 'flex',
    flexDirection: 'column'
  },
  orangeLink: {
    justifyContent: 'flex-start',
    height: 30,
    padding: 0,
    fontSize: 14,
    fontWeight: 600,
    color: theme.colorPalette.orange_50,
    '&:hover': {
      backgroundColor: 'transparent'
    },
    // Reskin: a text action, not bark at rest, with the beige hover pill.
    ...reskinStyles(theme, {
      color: theme.colors.action_text,
      padding: theme.spacing(0, 3),
      borderRadius: 22,
      '&:hover': { backgroundColor: theme.colorPalette.beige_50 }
    })
  },
  linkContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  linkIcon: {
    width: 16,
    height: 16
  },
  arrowIcon: {
    width: 20,
    height: 24
  },
  infoBox: {
    backgroundColor: theme.colorPalette.beige_25,
    margin: theme.spacing(6, 0),
    padding: theme.spacing(4),
    boxShadow: 'none',
    fontSize: 14,
    '& > div': {
      alignItems: 'flex-start'
    },
    '& img': {
      paddingTop: theme.spacing(0.5)
    }
  },
  infoIcon: {
    marginRight: theme.spacing(2),
    marginTop: '2px',
    filter: `drop-shadow(0 0 0.5px ${theme.colorPalette.green_90})`
  },
  emailLink: {
    color: theme.colorPalette.orange_50,
    textDecoration: 'underline',
    cursor: 'pointer',
    display: 'inline'
  },
  descriptionOfPolicyChangesContainer: {
    backgroundColor: theme.colorPalette.beige_25,
    padding: theme.spacing(6, 0, 0, 0),
    boxShadow: 'none'
  },
  descriptionOfPolicyChangesContainerLight: {
    backgroundColor: 'transparent',
    borderRadius: theme.sizes.innerCorners
  },
  lightTitle: {
    fontWeight: 600,
    color: theme.colorPalette.green_100
  },
  pipChangeDescriptionLight: {
    color: theme.colorPalette.green_100
  },
  infoBoxText: {
    display: 'block'
  },
  descriptionOfPolicyChangesInfoBox: {
    padding: theme.spacing(0),
    backgroundColor: theme.colorPalette.beige_25
  },
  descriptionOfPolicyChangesInfoBoxLight: {
    backgroundColor: 'transparent',
    marginTop: theme.spacing(4),
    marginBottom: 0
  },
  descriptionOfPolicyChangesFormField: {
    margin: theme.spacing(6, 0, 0, 0)
  },
  sendFormActionButton: {
    color: theme.colorPalette.orange_50,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: 600,
    '&:disabled': {
      color: `${theme.colorPalette.orange_50} !important`,
      opacity: 0.5
    },
    '& img': {
      marginRight: theme.spacing(2)
    },
    // Reskin: a text action in the dark text green, not bark at rest.
    ...reskinStyles(theme, {
      color: theme.colors.action_text,
      '&:disabled': { color: `${theme.colors.action_text} !important`, opacity: 0.5 }
    })
  },
  divider: {
    margin: theme.spacing(4, 0)
  },
  generateFormAndCopyActionButton: {
    width: '100%',
    justifyContent: 'center'
  },
  emailContainer: {
    marginTop: theme.spacing(4)
  },
  loadingSpinner: {
    animation: 'spin 1s linear infinite'
  },
  preAcceptChangesVerificationContainer: {
    '& p': {
      margin: 0
    },
    '& ul': {
      margin: 0,
      paddingLeft: theme.spacing(6)
    }
  },
  internalNoteFieldContainer: {
    '& .MuiGrid-item': {
      maxWidth: '80% !important',
      flexBasis: '72% !important'
    }
  },
  tooltip: {
    margin: theme.spacing(0, 1),
    backgroundColor: theme.colors.tooltip_background,
    fontSize: 10
  }
}));

export default useStyles;
